export default __webpack_public_path__ + "static/media/dumus.f89e00d8.jpg";